import React from "react";
import Layout from "../components/Layout";
import RosterView from "./Roster";

export default function Kedatangan() {
  return (
    <Layout title="Kedatangan">
      <div className="space-y-4" data-testid="kedatangan-page">
        <RosterView />
      </div>
    </Layout>
  );
}
